var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echart-box-cla"},[_c('div',{staticClass:"chart_title_cla"},[_c('div',{staticClass:"title-bg-cla"}),_vm._v(" "),_c('div',{staticClass:"title-Text-cla"},[_vm._v(_vm._s(_vm.$t('dashboard.addDeviceBar')))])]),_vm._v(" "),_c('div',{staticClass:"echart-cla",attrs:{"id":"devAddBar"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46d33f31","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tenantManager/dashboard/newAddedTotal/newDevChar.vue
// module id = null
// module chunks = 